export default __webpack_public_path__ + "static/media/notifications.ad288ab7.svg";